export const COOKIE_CONSENT_KEY = 'mts-cookie-consent';
export const COOKIE_CONSENT_EVENT = 'mts-cookie-consent-change';

export const COOKIE_CONSENT = {
  ACCEPTED: 'accepted',
  DECLINED: 'declined',
};

export const getCookieConsent = () => {
  try {
    return localStorage.getItem(COOKIE_CONSENT_KEY);
  } catch {
    return null;
  }
};

export const setCookieConsent = (value) => {
  try {
    localStorage.setItem(COOKIE_CONSENT_KEY, value);
    window.dispatchEvent(new CustomEvent(COOKIE_CONSENT_EVENT, { detail: value }));
  } catch (error) {
    console.error('Unable to save cookie consent preference:', error);
  }
};

/** True when the user accepted optional cookies (Google Analytics and HubSpot). */
export const hasAnalyticsConsent = () => getCookieConsent() === COOKIE_CONSENT.ACCEPTED;
